module.exports = __webpack_public_path__ + "static/pexels-chaitaastic-1918291-a14f21ea8817480c7c6acb7029a95da5.jpg";